// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import { safeFormat } from 'app/common/lib/StringUtil';
import { Box, Text } from 'gestalt';

type Props = {|
  nuxStepIndex: number,
  showCounter?: boolean,
  numSteps: number,
|};

const NuxStepTracker = ({ nuxStepIndex, showCounter, numSteps }: Props) =>
  showCounter && numSteps > 1 ? (
    <Box>
      <Text size="md">
        {safeFormat(i18n._('Step {{current}} of {{total}}'), {
          current: `${nuxStepIndex + 1}`,
          total: `${numSteps}`,
        })}
      </Text>
    </Box>
  ) : null;

export default NuxStepTracker;
